import { Languages } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { supportedLanguages } from '@/i18n'
import { cn } from '@/utils/cn'

const languageLabels: Record<(typeof supportedLanguages)[number], string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
}

const compactLanguageLabels: Record<(typeof supportedLanguages)[number], string> = {
  fr: 'FR',
  en: 'EN',
  es: 'ES',
}

interface LanguageSwitcherProps {
  compact?: boolean
}

export default function LanguageSwitcher({
  compact = false,
}: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation()

  return (
    <label
      className={cn(
        'flex items-center gap-2 text-sm text-muted-foreground',
        compact &&
          'rounded-2xl border border-border/80 bg-card/88 px-3 py-2 shadow-sm backdrop-blur-sm',
      )}
    >
      <Languages className="h-4 w-4" />
      {!compact && <span>{t('language.label')}</span>}
      <select
        value={supportedLanguages.includes(i18n.language as (typeof supportedLanguages)[number])
          ? i18n.language
          : 'fr'}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
        className={cn(
          'rounded-md border border-border bg-background px-2 py-1 text-sm text-foreground',
          compact &&
            'w-[3rem] border-0 bg-transparent px-0 py-0 font-medium shadow-none focus:outline-none focus:ring-0',
        )}
        aria-label={t('language.label')}
      >
        {supportedLanguages.map((language) => (
          <option key={language} value={language}>
            {compact ? compactLanguageLabels[language] : languageLabels[language]}
          </option>
        ))}
      </select>
    </label>
  )
}
